// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as Emotion from "../bindings/Emotion.bs.js";
import * as Skeleton from "../components/Skeleton/Skeleton.bs.js";
import * as PostTeaser from "../components/PostTeaser/PostTeaser.bs.js";
import * as Typography from "../components/Typography/Typography.bs.js";
import * as AuthContext from "../context/AuthContext.bs.js";
import * as JsxRuntime from "react/jsx-runtime";
import * as RescriptReactRouter from "@rescript/react/src/RescriptReactRouter.bs.js";
import * as RescriptRelay_Query from "rescript-relay/src/RescriptRelay_Query.bs.js";
import * as PostsPageQuery_graphql from "../__generated__/PostsPageQuery_graphql.bs.js";
import * as RescriptReactErrorBoundary from "@rescript/react/src/RescriptReactErrorBoundary.bs.js";

let convertVariables = PostsPageQuery_graphql.Internal.convertVariables;

let convertResponse = PostsPageQuery_graphql.Internal.convertResponse;

let convertWrapRawResponse = PostsPageQuery_graphql.Internal.convertWrapRawResponse;

let use = RescriptRelay_Query.useQuery(convertVariables, PostsPageQuery_graphql.node, convertResponse);

let useLoader = RescriptRelay_Query.useLoader(convertVariables, PostsPageQuery_graphql.node, prim => prim);

let usePreloaded = RescriptRelay_Query.usePreloaded(PostsPageQuery_graphql.node, convertResponse, prim => prim);

let fetch = RescriptRelay_Query.fetch_(PostsPageQuery_graphql.node, convertResponse, convertVariables);

let fetchPromised = RescriptRelay_Query.fetchPromised(PostsPageQuery_graphql.node, convertResponse, convertVariables);

let retain = RescriptRelay_Query.retain(PostsPageQuery_graphql.node, convertVariables);

let PostsQuery = {
  Operation: undefined,
  Types: undefined,
  convertVariables: convertVariables,
  convertResponse: convertResponse,
  convertWrapRawResponse: convertWrapRawResponse,
  use: use,
  useLoader: useLoader,
  usePreloaded: usePreloaded,
  fetch: fetch,
  fetchPromised: fetchPromised,
  retain: retain
};

function PostsPage$PostsList(props) {
  let data = use(undefined, undefined, undefined, undefined);
  return JsxRuntime.jsx("div", {
    children: data.posts.map(post => JsxRuntime.jsx(PostTeaser.PostTeaser.make, {
      id: post.id,
      title: post.title,
      body: post.body,
      authorName: post.author.name,
      createdAt: post.createdAt
    }, post.id))
  });
}

let PostsList = {
  make: PostsPage$PostsList
};

function PostsPage$ServerUnavailable(props) {
  let containerStyles = Emotion.Css.css({
    borderTop: `2px solid ` + Emotion.Utils.Color.primary,
    padding: "2rem 0"
  });
  return JsxRuntime.jsxs("div", {
    children: [
      JsxRuntime.jsx(Typography.Typography.Heading.make, {
        level: "h3",
        children: "GraphQL Server Not Running"
      }),
      JsxRuntime.jsx(Typography.Typography.Body.make, {
        className: Emotion.Css.css({
          color: Emotion.Utils.Color.textSecondary
        }),
        children: "Start the mock server to see posts:"
      }),
      JsxRuntime.jsx("code", {
        children: "bun run dev:server",
        className: Emotion.Css.css({
          display: "block",
          padding: "0.75rem 1rem",
          marginTop: "0.75rem",
          backgroundColor: Emotion.Utils.Color.bgElevated,
          fontSize: "0.875rem",
          color: Emotion.Utils.Color.primary
        })
      })
    ],
    className: containerStyles
  });
}

let ServerUnavailable = {
  make: PostsPage$ServerUnavailable
};

function PostsPage(props) {
  let auth = AuthContext.useAuth();
  let match = auth.state;
  let writePath;
  writePath = typeof match !== "object" ? "/login" : "/journal";
  let match$1 = auth.state;
  let writeLabel;
  writeLabel = typeof match$1 !== "object" ? "Sign in to write" : "Write in the journal";
  let containerStyles = Emotion.Css.css({
    padding: "4rem 1rem",
    maxWidth: "680px",
    margin: "0 auto"
  });
  return JsxRuntime.jsxs("div", {
    children: [
      JsxRuntime.jsxs("div", {
        children: [
          JsxRuntime.jsxs("div", {
            children: [
              JsxRuntime.jsx(Typography.Typography.Overline.make, {
                children: "Index"
              }),
              JsxRuntime.jsx(Typography.Typography.Heading.make, {
                level: "h1",
                size: "3xl",
                className: Emotion.Css.css({
                  marginTop: "0.5rem"
                }),
                children: "All writing"
              })
            ]
          }),
          JsxRuntime.jsx("a", {
            children: writeLabel,
            className: Emotion.Css.css({
              color: Emotion.Utils.Color.primary,
              fontSize: "0.75rem",
              letterSpacing: "0.08em",
              textTransform: "uppercase",
              textDecoration: "none",
              fontWeight: "600",
              whiteSpace: "nowrap"
            }),
            href: writePath,
            onClick: evt => {
              evt.preventDefault();
              RescriptReactRouter.push(writePath);
            }
          })
        ],
        className: Emotion.Css.css({
          display: "flex",
          justifyContent: "space-between",
          alignItems: "flex-end",
          gap: "1rem",
          marginBottom: "2rem"
        })
      }),
      JsxRuntime.jsx(RescriptReactErrorBoundary.make, {
        children: JsxRuntime.jsx(React.Suspense, {
          children: JsxRuntime.jsx(PostsPage$PostsList, {}),
          fallback: JsxRuntime.jsxs("div", {
            children: [
              JsxRuntime.jsx(Skeleton.Skeleton.make, {
                variant: "title",
                width: "40%"
              }),
              JsxRuntime.jsx(Skeleton.Skeleton.Stack.make, {
                count: 3
              }),
              JsxRuntime.jsx(Skeleton.Skeleton.make, {
                variant: "title",
                width: "55%"
              }),
              JsxRuntime.jsx(Skeleton.Skeleton.Stack.make, {
                count: 2
              })
            ],
            className: Emotion.Css.css({
              display: "flex",
              flexDirection: "column",
              gap: "2rem"
            })
          })
        }),
        fallback: param => JsxRuntime.jsx(PostsPage$ServerUnavailable, {})
      })
    ],
    className: containerStyles
  });
}

let Skeleton$1;

let PostTeaser$1;

let Typography$1;

let make = PostsPage;

export {
  Skeleton$1 as Skeleton,
  PostTeaser$1 as PostTeaser,
  Typography$1 as Typography,
  PostsQuery,
  PostsList,
  ServerUnavailable,
  make,
}
/* use Not a pure module */
